// extracted by mini-css-extract-plugin
var _1 = "mhnQH";
var _2 = "AzJvE";
var _3 = "GUL3y";
export { _1 as "base", _2 as "theme-dark", _3 as "theme-light" }
